import * as CL from '@design-system/component-library';
import { RecordInput } from './RecordInput.js';

export const TXTValueField = ({ index }: { index: number }) => (
  <CL.GridCol colsXS={4}>
    <RecordInput name="value" index={index} />
  </CL.GridCol>
);
